import { apiClient } from '@/to-fsd/shared/api';

export const getProblemCase = problemCaseId => {
  return apiClient.get(`/merchant/merchant/merchants/problem-cases/${problemCaseId}`);
};

export const getProblemCaseStatuses = params => {
  return apiClient.get(`/merchant/merchant/merchants/problem-cases/statuses`, { params });
};

export const problemCaseSetComment = (problemCaseId, payload) => {
  return apiClient.put(`/merchant/merchant/merchants/problem-cases/${problemCaseId}/set-comment`, payload);
};

export const updateProblemCaseStatus = (problemCaseId, body) => {
  return apiClient.put(`/merchant/merchant/merchants/problem-cases/${problemCaseId}/set-status`, body);
};

export const getProblemCases = params => {
  return apiClient.get('/merchant/merchant/merchants/problem-cases', { params });
};

export const getProblemCaseClients = params => {
  return apiClient.get('/merchant/core/clients/clients-pc', { params });
};
